//@ts-check
// Global busy overlay. Cloaks the page during async work (sign out, form saves, etc.) to signal
// progress and block further clicks. A single <LoadingOverlay> in the root layout renders this
// state. Reference-counted (`count`) so overlapping operations don't hide it prematurely.

export const overlay = $state({ count: 0, message: '' });

/**
 * Show the overlay (increments the busy count). Pair every call with hideOverlay(), or prefer
 * withOverlay() which guarantees it. The latest non-empty message wins while shown.
 * @param {string} [message] optional caption (e.g. "Signing out…", "Saving…")
 */
export function showOverlay(message = '') {
	if (message) overlay.message = message;
	overlay.count += 1;
}

/** Hide one level of the overlay; clears the message once nothing is busy. */
export function hideOverlay() {
	overlay.count = Math.max(0, overlay.count - 1);
	if (overlay.count === 0) overlay.message = '';
}

/**
 * Run an async function with the overlay shown, hiding it afterward even if it throws.
 * Use for form saves and other awaited work: await withOverlay(() => save(...), 'Saving…').
 * @template T
 * @param {() => Promise<T>} fn
 * @param {string} [message]
 * @returns {Promise<T>}
 */
export async function withOverlay(fn, message = '') {
	showOverlay(message);
	try {
		return await fn();
	} finally {
		hideOverlay();
	}
}
